import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

export const MonthlyBarChart = ({ data, isEHC }: any) => {
  const transformedData = data.map((item: any) => ({
    ...item,
    Wix: item.count - item.App,
  }));

  return (
    <BarChart
      width={1200}
      height={500}
      data={transformedData}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis
        dataKey="date"
        angle={-45}
        interval={0}
        tick={{ fontSize: 12, fontWeight: "bold" }}
        height={65}
        dy={25}
        dx={-25}
      />
      <YAxis />
      <Tooltip />
      {isEHC && <Legend />}
      <Bar dataKey={isEHC ? "Wix" : "count"} stackId="a" fill="#8884d8" />
      {isEHC && <Bar dataKey="App" stackId="a" fill="#a0a7e6" />}
    </BarChart>
  );
};
